import store from './store'
import { STORE_AREA_INFO_KEY } from '../constans/common'
/**
 * 计算区域中心点经纬度
 * @param {array} positionList
 */
export const calculateCenter = (positionList) => {
    const total = positionList.length
    let X = 0
    let Y = 0
    let Z = 0

    positionList.forEach((lnglat) => {
        const lng = (lnglat[0] * Math.PI) / 180
        const lat = (lnglat[1] * Math.PI) / 180
        let x
        let y
        let z
        x = Math.cos(lat) * Math.cos(lng)
        y = Math.cos(lat) * Math.sin(lng)
        z = Math.sin(lat)
        X += x
        Y += y
        Z += z
    })

    X = X / total
    Y = Y / total
    Z = Z / total

    const Lng = Math.atan2(Y, X)
    const Hyp = Math.sqrt(X * X + Y * Y)
    const Lat = Math.atan2(Z, Hyp)

    return [(Lng * 180) / Math.PI, (Lat * 180) / Math.PI]
}
export function toTnteger(num) {
    if (num && num.toString().indexOf(',') != -1) {
        num = num.replace(/,/g, '')
    }
    if (Number(num)) {
        return parseInt(Number(num))
    } else {
        return ''
    }
}
/**
 * 判断是否传locId
 */
export function getLocId() {
    let locId = undefined
    const tuLiuLocId = store.getValue(STORE_AREA_INFO_KEY).tuLiuLocId
    if (typeof tuLiuLocId === 'number') {
        locId = store.getValue(STORE_AREA_INFO_KEY).tid
    } else {
        locId = undefined
    }
    return locId
}

function prefix(str, separator = 0) {
    return str.toString().replace(/^\d{1}$/, `${separator}${str}`)
}

/**
 * @description: 时间格式化
 * @param {String|Number} timestamp: 时间戳，可选，默认当前时间，时间戳格式为 linux 自动转换成 js 时间戳的格式
 * @param {String} separator: 时间分隔符，默认 -
 * @param {String} type: all|date|time 返回所有|日期|时间
 * @return {String}
 */
export function formatDate(
    timestamp,
    { separator = '-', type = 'all', sep = ' ' } = {}
) {
    const formatTimestamp =
        timestamp && timestamp.toString().length <= 10
            ? `${timestamp}100`
            : timestamp
    const _date = formatTimestamp
        ? new Date(Number(formatTimestamp))
        : new Date()
    const date = [_date.getFullYear(), _date.getMonth() + 1, _date.getDate()]
        .map((date) => prefix(date))
        .join(separator)
    const time = `${prefix(_date.getHours())}:${prefix(
        _date.getMinutes()
    )}:${prefix(_date.getSeconds())}`
    return type === 'all'
        ? `${date}${sep}${time}`
        : type === 'date'
        ? date
        : time
}

// 获取指定日期前或后多少天
export function getBeforeDate(num, time) {
    let n = num
    let d = ''
    if (time) {
        d = new Date(time)
    } else {
        d = new Date()
    }
    let year = d.getFullYear()
    let mon = d.getMonth() + 1
    let day = d.getDate()
    if (day <= n) {
        if (mon > 1) {
            mon = mon - 1
        } else {
            year = year - 1
            mon = 12
        }
    }
    d.setDate(d.getDate() - n)
    year = d.getFullYear()
    mon = d.getMonth() + 1
    day = d.getDate()
    let s =
        year +
        '-' +
        (mon < 10 ? '0' + mon : mon) +
        '-' +
        (day < 10 ? '0' + day : day)
    return s
}

/**
 * @description: 判断两个数组是否相等
 * @param {Array} source: 数组 1
 * @param {Array} target: 数组 2
 * @return {Boolean}
 */
export function arrayCompare(source, target) {
    return (
        source.length == target.length &&
        source.every((item, index) => item.op == target[index].op)
    )
}

/**
 * @description: 保留小数点后几位
 * @param {Number} x: 值
 * @param {Number} n: 100 === 2、1000 === 3......
 * @param {Number} w: 保留几位
 * @return {String}
 */
export function keepDecimal(x, n, w) {
    let f = parseFloat(x)
    if (isNaN(f)) {
        return false
    }
    f = Math.floor(x * n) / n
    let s = f.toString()
    let rs = s.indexOf('.')
    if (rs < 0) {
        rs = s.length
        s += '.'
    }
    while (s.length <= rs + w) {
        s += '0'
    }
    return s
}

export const MAP_CENTER = [28.106554710320925, 115.817240843028728]

// 处理后台返回的数据
export const handleData = (data) => {
    let target = data.map((item) => {
        item.key = Object.keys(item)[0]
        item.value = Object.values(item)[0]

        return item
    })

    return target
}

// 合并数组中 value 值
export const mergeArrayValue = (data) => {
    return data.reduce((pre, cur) => {
        return Number(pre) + Number(cur.value)
    }, 0)
}

// 取数组中最大值
export const arrayMaxValue = (array) => {
    return Math.max.apply(null, array)
}

// 取数组中最小值
export const arrayMinValue = (array) => {
    return Math.min.apply(null, array)
}

// 判断类型
export const typeOf = (data) => {
    return Object.prototype.toString.call(data).slice(8, -1)
}

// 是否是数组
export const isArray = (data) => {
    return typeOf(data) === 'Array'
}

export const chartFormat = (data) => {
    const result = {
        valueAxis: [],
        series: [],
        subSeries: [],
        colors: [],
        units: []
    }
    if (!isArray(data)) return result

    return data.reduce((prev, cur) => {
        prev.valueAxis.push(cur.name)
        prev.series.push(cur.value !== undefined ? cur.value : cur.jobArea)
        prev.subSeries.push(cur.num || cur.cnt)
        prev.colors.push(cur.color)
        prev.units.push(cur.unit)

        return prev
    }, result)
}
